import {IPassengerSegmentBoardingPassViewModel} from "../../booking/boarding-pass/passenger-segment-boarding-pass-view-model.interface";
import {IServiceFactory} from "../../service-factory.interface";
import {action, makeObservable, observable} from "mobx";
import {UserLocalStorageKeys} from "../../storage/user-local-storage/user-local-storage-keys";

export class BoardingPassesStorage {
    constructor(private readonly services: IServiceFactory,
                private readonly storageKey: UserLocalStorageKeys) {
        this.boardingPasses = services.userLocalStorage.getJson<Record<string, IPassengerSegmentBoardingPassViewModel[]>>(storageKey) || {};

        makeObservable(this, {
            boardingPasses: observable,
            saveBoardingPasses: action.bound,
            removeBoardingPasses: action.bound
        });
    }

    readonly boardingPasses: Record<string, IPassengerSegmentBoardingPassViewModel[]>;


    private _persistBoardingPasses(): void {
        this.services.userLocalStorage.setJson(this.storageKey, this.boardingPasses);
    }

    saveBoardingPasses(newBoardingPasses: IPassengerSegmentBoardingPassViewModel[]): IPassengerSegmentBoardingPassViewModel[] {
        const newBoardingPassesGroupedByTripReferenceKey = newBoardingPasses.groupByKey(bPass => bPass.tripReferenceKey);

        Object.keys(newBoardingPassesGroupedByTripReferenceKey).forEach(key => {
            this.boardingPasses[key] = newBoardingPassesGroupedByTripReferenceKey[key];
        });

        this._persistBoardingPasses();

        return newBoardingPasses;
    }

    getBoardingPasses(tripReferenceKey: string): IPassengerSegmentBoardingPassViewModel[] {
        return this.boardingPasses[tripReferenceKey] || [];
    }

    removeBoardingPasses(tripReferenceKeys: string[]): void {
        tripReferenceKeys.forEach(key => {
            if(this.boardingPasses[key]) {
                delete this.boardingPasses[key];
            }
        });

        this._persistBoardingPasses();
    }
}
